export const NEW_MESSAGE = 'NEW_MESSAGE'
export const ADD_WALL = 'ADD_WALL'
export const REMOVE_LAST_MESSAGE = 'REMOVE_LAST_MESSAGE'
